module.exports = __webpack_public_path__ + "img/code2.7d297a8f.png";